export default "__VITE_ASSET__37a8c2b4__"